import { apiClient, APPOINTMENTS, WEBSITE_APPOINTMENTS } from '../../../shared/api';

const INCLUDE_PARAMS = 'tags,users';

export const createAppointment = async (appointmentData) => {
  const { description, endAt, startAt, title, userId } = appointmentData;

  const requestBody = {
    appointment: {
      description,
      end_at: endAt,
      start_at: startAt,
      title,
      user_ids: [userId],
    },
  };

  const params = {
    include: INCLUDE_PARAMS,
  };

  const response = await apiClient.post(WEBSITE_APPOINTMENTS(), requestBody, {
    params,
  });

  return response.data;
};

export const deleteAppointment = async (appointmentId) => {
  await apiClient.delete(`${APPOINTMENTS}/${appointmentId}`);
};

export const fetchAppointments = async () => {
  const params = {
    include: INCLUDE_PARAMS,
  };

  const response = await apiClient.get(WEBSITE_APPOINTMENTS(), { params });

  return response.data;
};

export const updateAppointment = async ({ appointmentData, appointmentId }) => {
  const { description, endAt, startAt, title, userId } = appointmentData;

  const requestBody = {
    appointment: {
      description,
      end_at: endAt,
      start_at: startAt,
      title,
      user_ids: [userId],
    },
  };

  const params = {
    include: INCLUDE_PARAMS,
  };

  const response = await apiClient.patch(
    `${APPOINTMENTS}/${appointmentId}`,
    requestBody,
    {
      params,
    }
  );

  return response.data;
};
